<div [ngClass]="['information-bar', severity]">
  <app-svg-icon [name]="getIcon" [ngClass]="['icon', severity]"></app-svg-icon>
  <ng-content></ng-content>
</div>
